import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {RedirectService} from '../../../services/infrastructure/page/routing/redirect/redirect.service';
import {Links} from '../../../common/constants/links';
import {environment} from '../../../../../environments/environment';
import {UrlFunctions} from '../../../common/functions/url';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
  ],
})
export class FooterComponent {

  private redirectService = inject(RedirectService);

  public LINKS = Links;

  public currentYear: number = new Date().getFullYear();

  public readonly feedbackEmail: string = environment.feedbackEmail;

  public readonly supportMailto: string = UrlFunctions.buildMailto(environment.feedbackEmail);

  /**
   * Method: Get Redirect link
   * @param request
   */
  getRedirectLink(request: string): string {
    return this.redirectService.getRedirectSobradoLink(request);
  }

}
